module.exports = __webpack_public_path__ + "static/img/passport.9608d3c8.png";